import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";

export const LayoutFieldTypes = Type.Union(
  [
    Type.Literal("string"),
    Type.Literal("email"),
    Type.Literal("phone"),
    Type.Literal("textarea"),
    Type.Literal("whatslly"),
    Type.Literal("boolean"),
    Type.Literal("checkbox"),
    Type.Literal("date"),
    Type.Literal("picklist"),
    Type.Literal("combobox"),
    Type.Literal("datetime"),
    Type.Literal("time"),
    Type.Literal("currency"),
    Type.Literal("double"),
    Type.Literal("int"),
    Type.Literal("percent"),
    Type.Literal("url"),
    Type.Literal("address"),
    Type.Literal("id"),
    Type.Literal("reference"),
    Type.Literal("eventDateTimePicker"),
    Type.Literal("eventAttendees"),
    Type.Literal("multipicklist"),
  ],
  { description: "type" }
);

export type LayoutFieldTypesType = TypeBoxToType<typeof LayoutFieldTypes>;

export const LayoutField = Type.Object({
  l: Type.String({ description: "Label Name" }),
  a: Type.String({ description: "API Name" }),
  t: LayoutFieldTypes,
  r: Type.Boolean({ description: "required" }),
  d: Type.Boolean({ description: "deletable" }),
  order: Type.Optional(Type.Number()),
  pickListOptions: Type.Optional(
    Type.Array(
      Type.Object({
        label: Type.String(),
        value: Type.String(),
      })
    )
  ),
  ro: Type.Optional(Type.Boolean({ description: "read only" })),
  refTo: Type.Optional(Type.Array(Type.String({ description: "reference to" }))),
  relationshipName: Type.Optional(Type.String({ description: "reference relationship name" })),
  relationshipFieldName: Type.Optional(Type.String({ description: "reference relationship field name - default Name" })),
  defaultValue: Type.Optional(Type.Union([Type.String(), Type.Number()])),
  minValue: Type.Optional(Type.Number()),
  maxValue: Type.Optional(Type.Number()),
  ref: Type.Optional(
    Type.Object({
      dependsOn: Type.Optional(Type.Array(Type.String())),
      apiName: Type.String(),
      orderField: Type.Optional(
        Type.String({
          description: "order lookup query filed name, default 'CreatedDate' filed",
        })
      ),
      searchField: Type.Optional(
        Type.String({
          description: "search lookup query filed name, default 'Name' filed",
        })
      ),
      lookupFieldId: Type.Optional(
        Type.String({
          description: "lookup entity field Id, default 'Id' filed",
        })
      ),
      lookupFilter: Type.Optional(
        Type.String({
          description: "extra lookup query where",
        })
      ),
    })
  ),
});

export type LayoutFieldType = TypeBoxToType<typeof LayoutField>;
